function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.lineChartIdentifiers = { key: false, id: false };
    model.rowChartIdentifiers = { key: false, id: false };
    model.geoChartIdentifiers = { key: false, id: false };
    model.sevLevIdentifiers = { key: false, id: false };
    model.tableIdentifiers =
        { key: false, id: false };

    socketIo('/api/hybrid_alerts/summary').then(function (socket) {
        /////////////////
        /// LINECHART ///
        /////////////////
        // register data object

        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'linechart',
                socket: socket
            },
            grouping: ['hour'],
            type: 'linechart',
            settings: {
                type: 'severity',
                xAxis: '',
                yAxis: '# Alerts / Hour'
            },
            searchCategories: {
                'time': 'Time',
            },
            dimension: function (cfObj) {
                return cfObj.dimension(function (d) {
                    if (d.hour !== 0) {
                        d.hour = d.hour*1000;
                        return d.hour;
                    }
                })
            },
            group: function (dimension) { // groups are optional and should default to a reduce if undefined
                return dimension.group().reduce(
                    function (p, v) {
                        if (v.ioc_severity === 1) {
                            p.guarded += v.ioc_count;
                        }
                        if (v.ioc_severity === 2) {
                            p.elevated += v.ioc_count;
                        }
                        if (v.ioc_severity === 3) {
                            p.high += v.ioc_count;
                        }
                        if (v.ioc_severity === 4) {
                            p.severe += v.ioc_count;
                        }
                        return p;
                    },
                    function (p, v) {
                        if (v.ioc_severity === 1) {
                            p.guarded -= v.ioc_count;
                        }
                        if (v.ioc_severity === 2) {
                            p.elevated -= v.ioc_count;
                        }
                        if (v.ioc_severity === 3) {
                            p.high -= v.ioc_count;
                        }
                        if (v.ioc_severity === 4) {
                            p.severe -= v.ioc_count;
                        }
                        return p;
                    },
                    function () {
                        return {
                            severe:0,
                            high:0,
                            elevated:0,
                            guarded:0
                        };
                    }
                );
            }, 
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.lineChartIdentifiers = {
                id: result.id,
                key: result.key
            }
            // set dimension & group
            $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            // stop spinner on complete
            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                usSpinnerService.stop('spinner-'+model.lineChartIdentifiers.id)
            }
        }, function (err) {
            console.log('chart error', err);

        }, function (result) {
            //console.log('chart result', result);
            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                $scope.$broadcast('init', model.lineChartIdentifiers);
                // stop spinner on inital data
                usSpinnerService.stop('spinner-'+model.lineChartIdentifiers.id)
            } else {
                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
            }
        })



        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['time', 'ipv4'],
            sort: { direction: "-", col: "ipv4" }, // "-"=desc, "+"=asc
            title: 'Alerts',
            columns: [
                { title: 'IPv4', select: 'ipv4', dView: true },
                { title: 'Total', select: 'total', dView: true },
                { title: 'NTA', select: 'nta', dView: true,
                    link: {
                        type: 'hybrid_alerts/nta_details',
                        val: ['ipv4'],
                        crumb: false
                    },
                },
                { title: 'UEBA', select: 'ueba', dView: true,
                    link: {
                        type: 'hybrid_alerts/ueba_details',
                        val: ['ipv4'],
                        crumb: false
                    },

                },
            ],
            searchCategories: {
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {
            console.log('table error', err);

        }, function (result) {
            //console.log('table result', result.rows)
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error', err);
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;




/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hybrid_alerts/summary.ts
 **/